module.exports = __webpack_public_path__ + "media/images/lb/879-3b333a609d0ffa1aa734b2f9fe9e1dd1.svg";